import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, createStyleSheet } from 'material-ui/styles';
import classnames from 'classnames';
import Card, {CardActions} from 'material-ui/Card';
import Collapse from 'material-ui/transitions/Collapse';
import IconButton from 'material-ui/IconButton';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import Divider from 'material-ui/Divider';

import ClrList from './ClrList';
import sills from './sills';
import walls from './walls';

const styleSheet = createStyleSheet('ClrSelect', theme => ({
  card: {
    width: '100%',
    position: 'absolute',
    left: 0,
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  flexGrow: { flex: '1 1 auto' },
  pointer: {cursor: 'pointer'},
}));

class ClrSelect extends Component {

  state = {
    expanded_sill: false,
    expanded_wall: false,
  };

  handle_exp_sill_click = () => {
    this.setState({ expanded_sill: !this.state.expanded_sill });
  };

  handle_exp_wall_click = () => {
    this.setState({ expanded_wall: !this.state.expanded_wall });
  };

  render() {

    const {classes, top, clr_sill, clr_wall} = this.props;

    return (
      <Card className={classes.card} style={{top}}>

        <CardActions disableActionSpacing className={classes.pointer} onClick={this.handle_exp_sill_click} >
          <h3>Подоконники</h3>
          <div className={classes.flexGrow} />
          <IconButton
            className={classnames(classes.expand, {[classes.expandOpen]: this.state.expanded_sill})}
            aria-expanded={this.state.expanded_sill}
            aria-label="Show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        </CardActions>
        <Collapse in={this.state.expanded_sill} transitionDuration="auto" unmountOnExit>
          <ClrList list={sills} handleClick={clr_sill} />
        </Collapse>

        <Divider />

        <CardActions disableActionSpacing className={classes.pointer} onClick={this.handle_exp_wall_click} >
          <h3>Откосы</h3>
          <div className={classes.flexGrow} />
          <IconButton
            className={classnames(classes.expand, {[classes.expandOpen]: this.state.expanded_wall})}
            aria-expanded={this.state.expanded_wall}
            aria-label="Show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        </CardActions>
        <Collapse in={this.state.expanded_wall} transitionDuration="auto" unmountOnExit>
          <ClrList list={walls} handleClick={clr_wall} />
        </Collapse>

      </Card>
    );
  }
}

ClrSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  top: PropTypes.number.isRequired,
  clr_sill: PropTypes.func.isRequired,
  clr_wall: PropTypes.func.isRequired,
};

export default withStyles(styleSheet)(ClrSelect);


// WEBPACK FOOTER //
// ./src/ClrSelect/ClrSelect.js